import { getOrCreateSocket } from "socket/socket";
import { store } from "store/store";

// eslint-disable-next-line @typescript-eslint/naming-convention
export const debug_addFood = (count?: number) => {
  const socket = getOrCreateSocket();
  socket.emit("debug_addFood", store.currentRoom, count);
};
